/* eslint-disable  */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const AffirmForm = () => {
  const isCartLoaded = useSelector(
    (state) => state.cart.status === 'succeeded',
  );

  const { selectedSKU } = useSelector((state) => state.pdp);
  const { selectedVariantsForBundleItemProducts } = useSelector(
    (state) => state.bundlePdp ?? {},
  );

  const hasSelectedVariantsForBundle =
    selectedVariantsForBundleItemProducts &&
    Object.entries(selectedVariantsForBundleItemProducts)?.length > 0;

  useEffect(() => {
    const renderAffirm = () => {
      const _affirm_config = {
        public_api_key: `${process.env.AFFIRM_API_KEY}`,
        script: `${process.env.AFFIRM_SCRIPT_LOCATION}`,
      };
      (function (m, g, n, d, a, e, h, c) {
        var b = m[n] || {},
          k = document.createElement(e),
          p = document.getElementsByTagName(e)[0],
          l = function (a, b, c) {
            return function () {
              a[b]._.push([c, arguments]);
            };
          };
        b[d] = l(b, d, 'set');
        var f = b[d];
        b[a] = {};
        b[a]._ = [];
        f._ = [];
        b._ = [];
        b[a][h] = l(b, a, h);
        b[c] = function () {
          b._.push([h, arguments]);
        };
        a = 0;
        for (
          c =
            'set add save post open empty reset on off trigger ready setProduct'.split(
              ' ',
            );
          a < c.length;
          a++
        )
          f[c[a]] = l(b, d, c[a]);
        a = 0;
        for (c = ['get', 'token', 'url', 'items']; a < c.length; a++)
          f[c[a]] = function () {};
        k.async = !0;
        k.src = g[e];
        p.parentNode.insertBefore(k, p);
        delete g[e];
        f(g);
        m[n] = b;
      })(
        window,
        _affirm_config,
        'affirm',
        'checkout',
        'ui',
        'script',
        'ready',
        'jsReady',
      );
    };
    if (
      (isCartLoaded || selectedSKU || hasSelectedVariantsForBundle) &&
      !window.affirm
    ) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `${process.env.AFFIRM_SCRIPT_LOCATION}`;
      s.onload = renderAffirm;
      document.getElementsByTagName('body')[0].appendChild(s);
    }
  }, [isCartLoaded, selectedSKU, hasSelectedVariantsForBundle]);

  return null;
};

export default AffirmForm;
